import { Seo } from "@/components/common/Seo";
import { PageHero } from "@/components/common/Kinetic";

export const LegalPage = ({ path, title, metaTitle, description, updated, sections, testId }) => (
  <>
    <Seo path={path} title={metaTitle} description={description} />
    <PageHero testId={testId} eyebrow="Legal" lines={[title]} text={`Last updated: ${updated}`} />
    <section className="bg-white py-20 lg:py-24">
      <div className="container-q">
        <div className="max-w-3xl space-y-12">
          {sections.map((s) => (
            <div key={s.h}>
              <h2 className="text-xl font-bold tracking-tight text-slate-950 sm:text-2xl">{s.h}</h2>
              <div className="mt-4 space-y-4 text-[15px] leading-relaxed text-slate-600">
                {s.p.map((p, i) => <p key={i}>{p}</p>)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);
